/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Booking_TitleInputs */

const en_meta_showcase_booking_title = /** @type {(inputs: Meta_Showcase_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-Time Hotel Availability Calendar Demo | Lindevo`)
};

const lv_meta_showcase_booking_title = /** @type {(inputs: Meta_Showcase_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reāllaika pieejamības kalendārs viesnīcai | Lindevo`)
};

/**
* | output |
* | --- |
* | "Real-Time Hotel Availability Calendar Demo \| Lindevo" |
*
* @param {Meta_Showcase_Booking_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_booking_title = /** @type {((inputs?: Meta_Showcase_Booking_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Booking_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_booking_title(inputs)
	return en_meta_showcase_booking_title(inputs)
});